// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {CameraResolution, VideoDestinationFormat} from "@models";
import {SimEnumExtendedService} from "@services";

export interface DialogData_UpdateDialog extends MatDialogDataBaseInput {
	typeOfSelector: "OutputFormat" | "Framerate" | "Compression";
}
export interface DialogData_UpdateDialogOutput extends MatDialogDataBaseOutput {
	selectedValue: VideoDestinationFormat | number;
}

@Component({
	selector: "sim-update-camera-resolution-dialog",
	templateUrl: "./update-camera-resolution-dialog.component.html",
	styleUrls: ["./update-camera-resolution-dialog.component.scss"],
	standalone: false,
})
export class UpdateCameraResolutionDialogComponent extends BasicMaterialDialog<
	UpdateCameraResolutionDialogComponent,
	DialogData_UpdateDialog,
	DialogData_UpdateDialogOutput
> {
	public cameraDestinationFormats: {
		name: string;
		value: VideoDestinationFormat;
	}[] = null;

	selectedOutputFormat;
	numOfFramerate: number;
	numOfCompression: number;
	public resolutions: CameraResolution[] = null;

	constructor(
		private _simEnumService: SimEnumExtendedService,
		_injector: Injector,
	) {
		super(_injector);
		this.initializeCameraDestinationFormats();
	}
	ngOnInit(): void {}
	SetAllOutputFormat() {
		this.close({action: "ok", selectedValue: this.selectedOutputFormat});
		console.log(this.selectedOutputFormat);
	}
	SetAllFramerate() {
		this.close({action: "ok", selectedValue: this.numOfFramerate});
	}
	SetAllCompression() {
		this.close({action: "ok", selectedValue: this.numOfCompression});
	}

	private initializeCameraDestinationFormats() {
		this._simEnumService.getEnumByName("VideoDestinationFormat").then((getEnumByNameResult) => {
			this.cameraDestinationFormats = [];
			getEnumByNameResult.forEach((v) => {
				this.cameraDestinationFormats.push({
					name: v.name,
					value: v.intValue,
				});
			});
		});
	}
}
